import React from 'react';
import type { ReactNode } from 'react';
import { RelayEnvironmentProvider, useLazyLoadQuery } from 'react-relay';

import { getRelayEnvironment } from '@confluence/graphql-provider/entry-points/relayEnvironment.ts';
import { SpaceDetailProvider } from '@confluence/space-utils/entry-points/SpaceDetailProvider.ts';

import SpaceNavigationQueryArtifact, {
	type SpaceNavigationQuery,
	type SpaceNavigationQuery$variables,
} from './__generated__/SpaceNavigationQuery.graphql.ts';

type Props = {
	children: ReactNode;
	variables: SpaceNavigationQuery$variables;
	loading: boolean;
	hasError: boolean;
};

const SharedSpaceData = ({ children, variables, loading, hasError }: Props) => {
	// Read the exact operation owned by navigation. This reader never starts a request.
	const data = useLazyLoadQuery<SpaceNavigationQuery>(SpaceNavigationQueryArtifact, variables, {
		fetchPolicy: 'store-only',
	});
	return (
		<SpaceDetailProvider
			spaceKey={variables.spaceKey}
			loading={loading && !hasError}
			spaceFragmentRef={!loading && !hasError ? (data?.space?.sharedSpaceDetail ?? null) : null}
		>
			{children}
		</SpaceDetailProvider>
	);
};

export const SpaceNavigationSharedSpaceData = (props: Props): React.JSX.Element => (
	<RelayEnvironmentProvider environment={getRelayEnvironment()}>
		<SharedSpaceData {...props} />
	</RelayEnvironmentProvider>
);
